import { Form, Input } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

const ClientEmail: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Form.Item
      name="email"
      label="Email"
      rules={[
        {
          required: true,
          type: "email",
          message: t("error:email_is_required"),
        },
      ]}
    >
      <Input  />
    </Form.Item>
  );
};

export default ClientEmail;
